export default {
      id: "author-comments-white-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#author-comments-white-usage",
      toString: function () {
        return this.url;
      }
    }